<section class="w3l-form-25">
  <div class="form-inner-cont">
      <div class="w3l-form-25">
          <h1>{{ 'Advanced Search' | translate }}</h1>
      </div>
</div>
<div class="w3l-form-25">
  <button type="button" id="Arabic" name="Arabic"  style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;" (click)="switchArabic()">ع </button>
  <button type="button" id="English" name="English"  style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;" (click)="switchEnglish()">En</button>


</div>


</section>
<section class="w3l-hero-headers-11 p-sticky-md">
      <div class="top-header" >
              <div class="accounts" >
                  <ul>
                      <li style="align-items: center;"> </li>
                      <li></li>
                  </ul>
              </div>
              <div class="search" style="align-content: center;">
                  <form action="search-results.html" method="get" style="align-content: center;margin-left:25px;">
                      <input id="search1" name="search1"  type="text" [(ngModel)]="concode"   (keyup)="retriveContacts()" placeholder="Contact Code"  style="width: 7%;">
                      <input id="search2" name="search2"  type="text" [(ngModel)]="conaname"  (keyup)="retriveContacts()" placeholder="Contact Name"  style="width: 17%;">
                      <select id="type1" name="type1"  class="styled-input" style="width: 5%;height: 40px;border-color: rgba(23, 8, 39, 0.096);text-align: center;" required="" [(ngModel)]= "contype" [value]="contype" (change)="retriveContacts()" >
                        <option value=""></option>
                        <option value="أشخاص">أشخاض</option>
                        <option value="مرضى">مرضى</option>
                        <option value="أطباء">أطباء</option>
                        <option value="موردين">موردين</option>
                      </select>
                      <input id="mobile"  name="mobile"   type="text" [(ngModel)]="conmobile" (keyup)="retriveContacts()" placeholder="Mobile No."    style="width: 8%;">
                      <input id="tel1"    name="tel1"     type="text" [(ngModel)]="contel1"   (keyup)="retriveContacts()" placeholder="Telepone 1"    style="width: 16%;">
                      <input id="tel2"    name="tel2"     type="text" [(ngModel)]="contel2"   (keyup)="retriveContacts()" placeholder="Telepone 2"    style="width: 9%;">
                      <input id="tel3"    name="tel3"     type="text" [(ngModel)]="contel3"   (keyup)="retriveContacts()" placeholder="Telepone 3"    style="width: 9%;">

                  </form>
              </div>

      </div>
  </section>

  <table>
      <thead>
          <tr>
              <th style="width: 7%;">{{ 'Code' | translate }}</th>
              <th style="width: 20%;">{{ 'Name' | translate }}</th>
              <th style="width: 5%;">{{ 'Type' | translate }}</th>
              <th style="width: 10%;">{{ 'Mobile No.' | translate }}</th>
              <th style="width: 18%;">{{ 'Telephone 1' | translate }}</th>
              <th style="width: 10%;">{{ 'Telephone 2' | translate }}</th>
              <th style="width: 10%;">{{ 'Telephone 3' | translate }}</th>
              <th style="width: 15%;">{{ 'E-Mail' | translate }}</th>
              <th style="width: 5%;">{{ 'Select' | translate }}</th>

          </tr>
      </thead>
      <tbody style="align-content: center;">
          <tr *ngFor="let pa of ContactsList; let i = index" >
              <td data-column="Patient ID" >{{pa.concode}}</td>
              <td data-column="Patient Name">{{pa.conaname}}</td>
              <td data-column="Cancer Type" >{{pa.contype}}</td>
              <td data-column="Mobile No." >{{pa.conmobile}}</td>
              <td data-column="Telephone No.1" >{{pa.contel1}}</td>
              <td data-column="Telephone No.2" >{{pa.contel2}}</td>
              <td data-column="birthDate No.3" >{{pa.contel3}}</td>
              <td data-column="email">{{pa.conemail}}</td>
              <td class="grid-td-th" data-column="Item Allocation">
                <a href={{Call_Contact}} class="drop-text">
                <button mat-raised-button  name="select" id="select" class="fa fa-pencil-square-o"  style="width:20px;background-color:#143d7b88;color: #fcfcfc; height: 30px; font-size: 85%;font-weight: bolder;" (click)="OpenDialogCall(pa)" >{{'Select' | translate}}</button>
                </a>
              </td>
            </tr>
      </tbody>
  </table>

